import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularMaterialModule } from '../angular-material.module';
import { FeatureRoutingModule } from './feature-routing.module';
import { LandingPageModule } from './landing-page/landing-page.module';
import { UserComponent } from './user/user.component';
import { UsersComponent } from './users/users.component';
import { AboutUsComponent } from './users/about-us/about-us.component';
import { InterventionMapComponent } from './users/intervention-map/intervention-map.component';
import { ResourceComponent } from './resource/resource.component';
import { SubresourceComponent } from './resource/subresource/subresource.component';
import { NgxHideOnScrollModule } from 'ngx-hide-on-scroll';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component';
import { ChatBotComponent } from './users/chat-bot/chat-bot.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxCaptchaModule } from 'ngx-captcha';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ClipboardModule } from 'ngx-clipboard';
import { PdfViewerComponent } from './pdf-viewer/pdf-viewer.component';
import { PopUpComponent } from './pop-up/pop-up.component';
import { ToastrModule, ToastNoAnimation, ToastNoAnimationModule } from 'ngx-toastr';
import { DynamicHooksModule, HookParserEntry } from 'ngx-dynamic-hooks';
import { BrowserModule, Title } from '@angular/platform-browser';
//import { NgxContentfulRichTextModule } from 'ngx-contentful-rich-text';
import { ContentfulService } from '../services/contentful.service';
import { QsaVideoComponent } from './qsa-video/qsa-video.component';
import { QsaGinaComponent } from './qsa-gina/qsa-gina.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { PharmacyComponent } from './pharmacy/pharmacy.component';
// import { GoogleTagManagerService } from "angular-google-tag-manager";
// import { GoogleTagManagerModule } from 'angular-google-tag-manager';





const componentParsers: Array<HookParserEntry> = [
  {
    component: ResourceComponent
  },
];

const dynamicComponents = [
  ResourceComponent,
];

@NgModule({
  declarations: [UserComponent, UsersComponent,AboutUsComponent,
    InterventionMapComponent,ChatBotComponent, ResourceComponent, 
    SubresourceComponent, LandingPageComponent, PrivacyPolicyComponent, 
    TermsOfUseComponent, PdfViewerComponent, PopUpComponent, ...dynamicComponents,
     QsaVideoComponent, QsaGinaComponent, ContactUsComponent, PharmacyComponent],
     
  imports: [
    CommonModule,
    FeatureRoutingModule,
    AngularMaterialModule,
    NgxHideOnScrollModule,
    LandingPageModule,
    NgxCaptchaModule,
    RouterModule,
    FormsModule,ReactiveFormsModule,
    PdfViewerModule,
    ClipboardModule,
    //NgxContentfulRichTextModule,
    // GoogleTagManagerModule.forRoot({
    //   id: "GTM-TSRXCXP"
    // }),
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-right',
      timeOut: 3000,
    }),
    DynamicHooksModule.forRoot({
      globalParsers: componentParsers
    }),
    // ToastNoAnimationModule.forRoot({
    //   timeOut: 1000,
    //   positionClass: 'toast-bottom-right',
    // }),
    // ToastNoAnimation
  ],
  entryComponents:[...dynamicComponents],
  providers :[...dynamicComponents, ContentfulService, Title, 
    //{provide: "googleTagManagerId", useValue: "GTM-TSRXCXP"}, GoogleTagManagerService
  ]
})
export class FeatureModule { }
